export const removeElementsFromArray = <T>(
  array: T[],
  ...toRemove: T[]
): T[] => {
  return array.filter((item) => !toRemove.includes(item));
};
